import React, {FC, ReactElement} from 'react';
import styles from './index.module.scss';

interface Props {
    content: string
}

const LoadingModal: FC<Props> = ({content}): ReactElement => {
    return (
        <div className={styles.modal}>
            <div className={styles.contentCss}>
                <img src={require('img/loading.gif').default} alt=''/>
                <p>{content}</p>
            </div>
        </div>
    )
}

export default LoadingModal
